import { ChannelMessage } from '../model';
import { mapMessage } from './map-message';

type MapMessages = (data: any) => Array<ChannelMessage>;

export const mapMessages: MapMessages = (data: any) => {
  return data.data.content.map((message: any) => mapMessage(message));
};
